import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import * as React from 'react';
import type { ComparisonProduct } from './types';
import ChevronIcon from '@repo/ui/src/components/Icons/ChevronIcon';
import { classNames } from '@repo/ui/src/utils/classNames';

interface Props {
  products: Array<ComparisonProduct>;
  sku: string | '';
  updateSelectedProducts: (sku: string, index: number) => void;
  index: number;
  asContentRow?: boolean;
  className?: string;
}

export const Dropdown = ({ sku, products, updateSelectedProducts, index, className }: Props) => {
  const { t } = useTranslation();

  const sortedProducts = products.reduce(
    (acc: Array<ComparisonProduct>, product) =>
      product.sku === sku ? [product, ...acc] : [...acc, product],
    [],
  );

  return (
    <div className={classNames('relative w-full pb-4 md:pb-0 xl:min-w-[370px]', className)}>
      <div className="relative w-full">
        <select
          value={sku}
          onChange={(e) => updateSelectedProducts(e.target.value, index)}
          aria-label={t('productComparisonContent.chooseGrillLabel', undefined, {
            default: 'Select a grill to compare',
          })}
          className="w-full appearance-none border-2 border-[#747778] bg-white text-left text-sm sm:text-base px-2 lg:px-4 py-2 pr-8 cursor-pointer focus:outline-brand-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
        >
          {!sku && (
            <option value="" disabled>
              {t('productComparisonContent.chooseGrillLabel', undefined, {
                default: 'Select a grill to compare',
              })}
            </option>
          )}
          {sortedProducts.map((product) => (
            <option key={product.sku} value={product.sku}>
              {product.title}
            </option>
          ))}
        </select>
        <div className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 w-5">
          <ChevronIcon direction="down" />
        </div>
      </div>
    </div>
  );
};

export default Dropdown;
